// Auth network layer. This is the only module that should talk to the auth API.
// Transport, CSRF and cookie rules live in apiClient.js.
//
// `primeCsrf()` must be called once before any POST (done on app load in App.js) —
// Django only sets the CSRF cookie on a request that explicitly asks for it.

import { API_BASE_URL, request } from "./apiClient";

function primeCsrf() {
  return fetch(`${API_BASE_URL}/auth/csrf/`, { credentials: "include" }).catch(() => {});
}

export const authService = {
  signIn: ({ email, password, rememberMe }) =>
    request("/auth/signin/", { method: "POST", body: { email, password, rememberMe } }),
  signUp: (payload) => request("/auth/signup/", { method: "POST", body: payload }),
  signOut: () => request("/auth/signout/", { method: "POST" }),
  me: () => request("/auth/me/"),
  requestPasswordReset: (email) =>
    request("/auth/password-reset/", { method: "POST", body: { email } }),
  confirmPasswordReset: ({ uid, token, password, confirmPassword }) =>
    request("/auth/password-reset/confirm/", { method: "POST", body: { uid, token, password, confirmPassword } }),
  changePassword: ({ currentPassword, newPassword }) =>
    request("/auth/password-change/", { method: "POST", body: { currentPassword, newPassword } }),
  verifyEmail: (token) => request("/auth/verify-email/", { method: "POST", body: { token } }),
  resendVerification: () => request("/auth/verify-email/resend/", { method: "POST" }),
  verificationResendStatus: () => request("/auth/verify-email/resend/status/"),
  deleteAccount: (password) => request("/auth/delete-account/", { method: "POST", body: { password } }),
  /** Remembers the UI language on the account so later emails match it.
      Fire-and-forget: a failure here must never block the language switch. */
  setLanguage: (language) =>
    request("/auth/language/", { method: "POST", body: { language } }).catch(() => {}),
  primeCsrf,
};
